class industriesRegister {

    static indutries = null;

    static setIndustries(indutries){
        industriesRegister.indutries = indutries;
    }

    static getIndustries(){
        return industriesRegister.indutries;
    }

    static removeIndustries(){
        industriesRegister.indutries = null;
    }

    //SHORTENER
    static set(indutries){
        industriesRegister.setIndustries(indutries);
    }

    static get(){
        return industriesRegister.getIndustries();
    }

    static remove(){
        industriesRegister.removeIndustries();
    }

}

export {industriesRegister}


// WEBPACK FOOTER //
// ./src/services/industriesRegister.js